import { createSelector } from '@ngrx/store';
import { locationsState } from '../root';

export const getLocations = createSelector(locationsState, (locations) => locations?.data);
